export default __webpack_public_path__ + "static/media/map_pin.23ad49d6.svg";